export default __webpack_public_path__ + "static/media/back-svgrepo-com.8a2d5008.svg";